import script from "./HomePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomePage.vue?vue&type=script&lang=ts&setup=true"

import "./HomePage.vue?vue&type=style&index=0&id=36415824&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36415824"]])

export default __exports__